import { render, staticRenderFns } from "./SCAudit.vue?vue&type=template&id=4cb3ec5e&"
import script from "./SCAudit.vue?vue&type=script&lang=js&"
export * from "./SCAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports